import { render, staticRenderFns } from "./VersionHistoryPopup.vue?vue&type=template&id=3d43e8d1&scoped=true&"
import script from "./VersionHistoryPopup.vue?vue&type=script&lang=js&"
export * from "./VersionHistoryPopup.vue?vue&type=script&lang=js&"
import style0 from "./VersionHistoryPopup.vue?vue&type=style&index=0&id=3d43e8d1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d43e8d1",
  null
  
)

export default component.exports